export default __webpack_public_path__ + "static/media/Head_4_Ear_3_C2.baeb810d.svg";